import React from 'react'
export default function Navigetaion() {
  return (
    <div children="p-4 item-center bg-green/40">
        <p className='text-center font-semibold py-2'> Welcome To Shop With Us</p>
       </div>
  )
}
